<template>
  <div class="login-container">
    <div class="login-wrapper">
      <div class="company-header">
        <img src="@/assets/logo2.png" alt="logo" class="logo">
        <h2 class="company-name">环海运通</h2>
      </div>
      <div class="login-form">
        <h2 class="title">船期管理系统</h2>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入用户名" prefix-icon="el-icon-user"/>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password"
              placeholder="请输入密码" prefix-icon="el-icon-lock" @keyup.enter.native="handleLogin"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;" :loading="loading" @click.native.prevent="handleLogin">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import userApi from '@/api/user.js'
import wsManager from '@/utils/websocket'
import { resetDynamicRoutesFlag, registerDynamicRoutes } from '@/router/routeRegistry'
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  created(){
    this.checkAccount()
  },
  methods: {
    checkAccount(){
      var account = localStorage.getItem('account')
      if(account){
        this.loginForm.username = account
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          var param = {acct:this.loginForm.username,password:this.loginForm.password}
          const res = await userApi.login(param)
          this.loading = false
          if(res.code == 200){
					  var userInfo = res.data
            localStorage.setItem('pms',JSON.stringify(userInfo.btnPms?userInfo.btnPms:[]))
            delete userInfo.btnPms
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('account', this.loginForm.username)
            if (userInfo.menus) {
              localStorage.setItem('userMenus', JSON.stringify(userInfo.menus))
            } else {
              localStorage.removeItem('userMenus')
            }
            resetDynamicRoutesFlag()
            const ok = await registerDynamicRoutes(true)
            if (!ok) {
              this.$message.warning('菜单加载失败，请刷新页面重试')
              return
            }
            this.$message.success('登录成功')
            this.$router.replace('/home').catch(() => {})
          }else{
            this.$message.error(res.msg)
            this.loading = false
          }
        }
      })
    },
    // 初始化WebSocket
    async initWebSocket(token) {
      try {
        // 初始化WebSocket连接并登录
        await wsManager.init()
        wsManager.login(token)
      } catch (error) {
        console.error('WebSocket初始化失败:', error)
      }
    }
  }
}
</script>
<style scoped>
.login-container {
  height: 98vh;
  background-image: url('@/assets/loginBack.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.company-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  gap: 12px;
}
.logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
.company-name {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin: 0;
  font-weight: bold;
  text-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5);
  letter-spacing: 2px;
  font-size: 90px;
}
.login-form {
  width: 400px;
  padding: 40px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
}
.title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-size: 25px;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}
</style>